import { render, staticRenderFns } from "./OrderCreated.vue?vue&type=template&id=5b938f48&"
import script from "./OrderCreated.vue?vue&type=script&lang=js&"
export * from "./OrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OrderCreated.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b938f48')) {
      api.createRecord('5b938f48', component.options)
    } else {
      api.reload('5b938f48', component.options)
    }
    module.hot.accept("./OrderCreated.vue?vue&type=template&id=5b938f48&", function () {
      api.rerender('5b938f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/OrderCreated.vue"
export default component.exports